import * as React from "react";

function SvgCalq(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1365 404.8 648 648.1"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path fill="#E95B5A" d="M1403.2 478h146.9v452.6h-146.9z" />
      <path fill="#AD4147" d="M1403.2 897.4h146.9v33.2h-146.9z" />
      <path fill="#CB5C5B" d="M1618 608.3h146.9v322.2H1618z" />
      <path fill="#9A474D" d="M1618 897.4h146.9v33.2H1618z" />
      <g>
        <path fill="#B15B5E" d="M1829.7 776.5h146.9v154h-146.9z" />
        <path fill="#89464D" d="M1829.7 897.4h146.9v33.2h-146.9z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgCalq);
